module.exports = __webpack_public_path__ + "static/media/sport-et-citoyennete.3a14ff06.jpg";